export const PACK_EMOJI_MAP: Record<string, string> = {
  talking_and_listening: '💬',
  big_feelings: '❤️',
  on_the_go: '🚗',
  calm_bedtimes: '🌙',
  messy_play: '🎨',
  little_scientists: '🔬',
  nature_explorers: '🌿'
};

export function getPackEmoji(key: string): string {
  return PACK_EMOJI_MAP[key] ?? '';
}